const pageState = JSON.parse(window.PAGE_STATE || '{}');
const matchRouteName = (routeName, isStrictSeach = true) => pageState.route
        && (pageState.route === routeName || (!isStrictSeach && pageState.route.startsWith(routeName)));

export {
    pageState,
    matchRouteName,
};
